import "@shoelace-style/shoelace/dist/components/tab-group/tab-group.js";
import "@shoelace-style/shoelace/dist/components/tab/tab.js";
import "@shoelace-style/shoelace/dist/components/tab-panel/tab-panel.js";

import { css, html } from "lit";
import { customElement, query, state } from "lit/decorators.js";
import { Style } from "./Styles";
import { BaseElement } from "./BaseElement";

import "./EntryDialog";
import "./DecimalDegreesInput";
import "./DMSToDecimalDegrees";

import { ILocation } from "../models/ILocation";
import { makeCustomEvent } from "../Utils";
import { DmsToDecimalDegrees } from "./DMSToDecimalDegrees";
import { DecimalDegreesInput } from "./DecimalDegreesInput";

import "./TextToDecimalDegrees";
@customElement("ds-go-to-location-control")
export class GoToLocationControl extends BaseElement {
    static override styles = [Style];

    @query("#dms") _dmsElement: DmsToDecimalDegrees | undefined;
    @query("#decimal") _decimalElement: DecimalDegreesInput | undefined;

    private _reset() {
        if (this._dmsElement) {
            this._dmsElement.reset();
        }
        if (this._decimalElement) {
            this._decimalElement.reset();
        }
    }

    override render() {
        return html` <sl-tab-group @sl-tab-hide=${() => this._reset()}>
            <sl-tab slot="nav" panel="dms">Deg/Min/Sec</sl-tab>
            <sl-tab slot="nav" panel="decimal">Decimal</sl-tab>
            <sl-tab slot="nav" panel="text">Text</sl-tab>

            <sl-tab-panel name="dms"
                ><ds-dms-to-decimal-degrees id="dms"></ds-dms-to-decimal-degrees
            ></sl-tab-panel>
            <sl-tab-panel name="decimal">
                <ds-decimal-degrees-input id="decimal"></ds-decimal-degrees-input>
            </sl-tab-panel>
            <sl-tab-panel name="text">
                <ds-text-to-decimal-degrees id="decimal"></ds-text-to-decimal-degrees>
            </sl-tab-panel>
        </sl-tab-group>`;
    }
}

@customElement("ds-go-to-location-dialog")
export class GoToLocationDialog extends BaseElement {
    static override styles = [
        Style,
        css`
            ds-entry-dialog {
                color: black;
            }
        `,
    ];

    @state() protected _location: ILocation | undefined;

    override render() {
        return html`<ds-entry-dialog
            open
            no-header
            label="Go to location"
            ?isValid=${!!this._location}
            acceptText="Go to location"
            @on-accept=${(e: CustomEvent) => {
                e.stopPropagation();
                this.dispatchEvent(
                    makeCustomEvent("on-accept", {
                        location: this._location,
                    })
                );
            }}
        >
            <ds-go-to-location-control
                @ds-changed=${(e: CustomEvent) => {
                    this._location = e.detail.location;
                    e.stopPropagation();
                }}
                @ds-error=${() => (this._location = undefined)}
            ></ds-go-to-location-control>
        </ds-entry-dialog>`;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        "ds-go-to-location-control": GoToLocationControl;
        "ds-go-to-location-dialog": GoToLocationDialog;
    }
}
